import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    private vesselUpdated$: Subject<{ vesselId: string; shipyardId: string }> = new Subject();
    private shipyardUpdated$: Subject<string> = new Subject();

    constructor() {}

    updateSelectedVessel(shipyardId, vesselId) {
        return this.vesselUpdated$.next({ shipyardId, vesselId });
    }

    updateSelectedShipyard(shipyardId) {
        return this.shipyardUpdated$.next(shipyardId);
    }

    vesselUpdatedSubject() {
        return this.vesselUpdated$;
    }

    shipyardUpdatedSubject() {
        return this.shipyardUpdated$;
    }
}
